import { render, staticRenderFns } from "./TrendingAppItemSkeleton.vue?vue&type=template&id=4f08d1b2"
var script = {}
import style0 from "./TrendingAppItemSkeleton.vue?vue&type=style&index=0&id=4f08d1b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports